import { render } from "./rzrq.vue?vue&type=template&id=df382e48&scoped=true&ts=true"
import script from "./rzrq.vue?vue&type=script&lang=ts"
export * from "./rzrq.vue?vue&type=script&lang=ts"

import "./rzrq.vue?vue&type=style&index=0&id=df382e48&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df382e48"]])

export default __exports__